import { getValue } from "@/shared/RxUtil";
import { checkIsDefined } from "@/shared/Preconditions";
const AUTHENTICATION_REQUIRED = "Authentication is required to like a tweet.";
export class LikeTweetUseCaseImpl {
    constructor(tweetRepository, authRepository) {
        this.tweetRepository = tweetRepository;
        this.authRepository = authRepository;
    }
    async likeTweet(id) {
        return this.tweetRepository.likeTweet(id, await this.getUserId());
    }
    async unlikeTweet(id) {
        return this.tweetRepository.unlikeTweet(id, await this.getUserId());
    }
    async getUserId() {
        const userId = await getValue(this.authRepository.userId);
        checkIsDefined(userId, AUTHENTICATION_REQUIRED);
        return userId;
    }
}
